import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

function Contact() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      once: true, // Animation happens only once
    });
  }, []);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div>
      <section id="contact" class="contact section">
        {/* Section Title */}
        <div class="container section-title" data-aos="fade-up">
          <h2>Contact</h2>
          <p>Get in touch with us!</p>
        </div>
        {/* End Section Title */}

        <div
          class="container"
          // data-aos="fade-up" data-aos-delay="100"
        >
          <div class="row gy-4">
            <div class="col-lg-6">
              <div
                class="info-item d-flex flex-column justify-content-center align-items-center"
                // data-aos="fade-up"
                //   data-aos-delay="200"
              >
                <i class="bi bi-geo-alt"></i>
                <h3>Address</h3>
                <p>NO 8, PLOT NO 29,</p>
                <p>56, HILL ROAD,</p>
                <p>BANDRA WEST, MUMBAI - 400 050</p>
                <p>MAHARASHTRA, INDIA</p>
              </div>
            </div>
            {/* End Info Item */}

            {/* <div class="col-lg-3 col-md-6">
      <div class="info-item d-flex flex-column justify-content-center align-items-center" 
      // data-aos="fade-up"
      //   data-aos-delay="300"
        >
        <i class="bi bi-telephone"></i>
        <h3>Call Us</h3>
        <p>+91 9833 326 434</p>
      </div>
    </div> */}

            <div class="col-lg-3 col-md-6">
              <div
                class="info-item d-flex flex-column justify-content-center align-items-center"
                // data-aos="fade-up"
                //   data-aos-delay="400"
              >
                <i class="bi bi-envelope"></i>
                <h3>Email Us</h3>
                <p>info@symholding.com</p>
              </div>
            </div>
            {/* End Info Item */}
          </div>

          <div class="row gy-4 mt-1">
            <div
              class="col-lg-6"
              // data-aos="fade-up" data-aos-delay="300"
            >
              <iframe
                title="googlemap"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15084.729330936912!2d72.81344587116223!3d19.05571936528976!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c93e44924f03%3A0xc58e5fe3523e260a!2s8%20%2C%20PLOT%20NO%2029%2C%2056%2C%20Hill%20Rd%2C%20near%20Bank%20Of%20India%2C%20Bandra%20West%2C%20Mumbai%2C%20Maharashtra%20400050!5e0!3m2!1sen!2sin!4v1741688843926!5m2!1sen!2sinhttps://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3771.1826581343935!2d72.82932507352521!3d19.055705052612634!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c93e44924f03%3A0xc58e5fe3523e260a!2s8%20%2C%20PLOT%20NO%2029%2C%2056%2C%20Hill%20Rd%2C%20near%20Bank%20Of%20India%2C%20Bandra%20West%2C%20Mumbai%2C%20Maharashtra%20400050!5e0!3m2!1sen!2sin!4v1741688955522!5m2!1sen!2sin"
                frameborder="0"
                style={{ border: "0", width: "100%", height: "400px" }}
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            {/* End Google Maps */}

            <div className="col-lg-6">
              <form
                // action="forms/contact.php"
                // method="post"
                className="php-email-form"
                // data-aos="fade-up"
                //   data-aos-delay="400"
              >
                <div className="row gy-4">
                  <div className="col-md-6">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Your Name"
                      required=""
                    />
                  </div>

                  <div className="col-md-6 ">
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      placeholder="Your Email"
                      required=""
                    />
                  </div>

                  <div class="col-md-12">
                    <input
                      type="text"
                      className="form-control"
                      name="subject"
                      placeholder="Subject"
                      required=""
                    />
                  </div>

                  <div class="col-md-12">
                    <textarea
                      className="form-control"
                      name="message"
                      rows="6"
                      placeholder="Message"
                      required=""
                    ></textarea>
                  </div>

                  <div className="col-md-12 text-center">
                    <div className="loading">Loading</div>
                    <div className="error-message"></div>
                    <div className="sent-message">
                      Your message has been sent. Thank you!
                    </div>

                    <button type="submit">Send Message</button>
                  </div>
                </div>
              </form>
            </div>
            {/* End Contact Form */}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
